import { SURVEY_LANGUAGE_STORAGE_KEY } from '@shared/constants/surveyLanguage';
import { clearAllLocalStorage } from '@/lib/clearAllLocalStorage';
import { TNG_REWARD_SESSION_KEY } from '@/lib/tngRewardSession';
import {
  PDPA_CONSENT_STORAGE_KEY,
  resetAppForNewCustomer,
  SURVEY_SCREENING_STORAGE_KEY,
  UNIQUE_CODE_DRAFT_STORAGE_KEY,
} from '@/stores/appSlice';
import { store } from '@/stores/store';

/**
 * Wipes survey drafts, app session keys (including TNG reward), and Redux.
 * Call when leaving `/tng` so the PIN screen can keep `tng_reward` until navigation away.
 */
export function performFullNewCustomerReset(): void {
  clearAllLocalStorage();
  try {
    sessionStorage.removeItem(SURVEY_LANGUAGE_STORAGE_KEY);
    sessionStorage.removeItem(SURVEY_SCREENING_STORAGE_KEY);
    sessionStorage.removeItem(PDPA_CONSENT_STORAGE_KEY);
    sessionStorage.removeItem(UNIQUE_CODE_DRAFT_STORAGE_KEY);
    sessionStorage.removeItem(TNG_REWARD_SESSION_KEY);
  } catch {
    /* private mode / quota */
  }
  store.dispatch(resetAppForNewCustomer());
}
